import { theme } from 'antd';

import { CustomThemeToken } from '@/theme';

const { useToken } = theme;

const PoweredOffIcon = ({
  width = 20,
  height = 20,
  ...rest
}: {
  width?: number;
  height?: number;
  [x: string]: unknown;
}) => {
  const { token } = useToken() as unknown as { token: CustomThemeToken };
  return (
    <svg width={width} height={height} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <path
        d="M3.125 3.75C3.125 3.40482 3.40482 3.125 3.75 3.125H16.25C16.5952 3.125 16.875 3.40482 16.875 3.75V16.25C16.875 16.5952 16.5952 16.875 16.25 16.875H3.75C3.40482 16.875 3.125 16.5952 3.125 16.25L3.125 3.75ZM5.875 10C5.875 12.2782 7.72183 14.125 10 14.125C12.2782 14.125 14.125 12.2782 14.125 10C14.125 7.72183 12.2782 5.875 10 5.875C7.72183 5.875 5.875 7.72183 5.875 10ZM7.875 10C7.875 8.8264 8.8264 7.875 10 7.875C11.1736 7.875 12.125 8.8264 12.125 10C12.125 11.1736 11.1736 12.125 10 12.125C8.8264 12.125 7.875 11.1736 7.875 10Z"
        fill={token.colorError}
      />
    </svg>
  );
};

export default PoweredOffIcon;
